export default __webpack_public_path__ + "static/mediaNews-dda743727edb7f8f50f330d4f27a1bca.png";